// TIER TWO OF THE HEADER: how am I looking at it, and whose.
//
// THREE GROUPS, AND THEY ARE NOT THE SAME KIND OF THING — which is exactly what the old
// single row hid. Each one gets a caption naming what it changes, because "this group
// changes the time range" is a fact the control should state rather than one you learn by
// clicking:
//   טווח   day / week / month     — WHICH window of time is fetched.
//   תצוגה  grid / list            — HOW that same window is drawn. Not a filter: the two
//                                   halves hold exactly the same meetings.
//   של מי  everyone / one partner — WHOSE meetings are shown, applied in the browser over
//                                   the window already fetched.
//
// EACH GROUP IS ONE OBJECT, NOT THREE PILLS. The buttons lose their separate borders and
// sit in a single grey track (see calendar.css), so the eye bounds a group before it reads
// any label — and the 32px between groups against 0 within them finally makes the spacing
// mean something. It used to be 8px against 6px, which is no distance at all.
//
// SELECTION IS A RAISED WHITE PILL, NOT A SOLID ACCENT ONE. That is the other half of the
// fix: a solid accent toggle is the same object as the primary action button beside it, so
// three pieces of STATE looked like three things to DO. Solid accent is now reserved for
// the one button on the screen that acts.
//
// The filter carries each partner's COLOUR DOT — the same colour their meetings are drawn
// in below (meetingColors). It ties "whose" to the grid at a glance, and it is the reason
// the default is "הכל" rather than one partner: a calendar that can only ever show one
// person has no use for colour-coding at all.
import he from '../../i18n/he';
import { colorForPartner } from './meetingColors';

const RANGES = ['day', 'week', 'month'];

// One group: its caption, then its track. A plain <button> rather than the shared Button
// component — Button composes its own className from `variant`, so it cannot be given the
// segment styling without either overriding that class (which would drop `.btn` entirely)
// or teaching a shared component about this one screen.
const Group = ({ label, children }) => (
  <div className="cal-group">
    <span className="cal-group-label">{label}</span>
    <div className="cal-seg">{children}</div>
  </div>
);

const Segment = ({ selected, onClick, children }) => (
  <button type="button" className={`cal-seg-btn${selected ? ' on' : ''}`} onClick={onClick}>
    {children}
  </button>
);

export default function CalendarViewBar({ view, onView, mode, onMode, filter, onFilter, partners, me }) {
  return (
    <div className="cal-view-bar">
      <Group label={he.calendar.groupRange}>
        {RANGES.map((r) => (
          <Segment key={r} selected={view === r} onClick={() => onView(r)}>
            {he.calendar[r]}
          </Segment>
        ))}
      </Group>

      <Group label={he.calendar.groupView}>
        <Segment selected={mode === 'grid'} onClick={() => onMode('grid')}>
          {he.calendar.viewGrid}
        </Segment>
        <Segment selected={mode === 'list'} onClick={() => onMode('list')}>
          {he.calendar.viewList}
        </Segment>
      </Group>

      <Group label={he.calendar.groupWho}>
        <Segment selected={filter === 'all'} onClick={() => onFilter('all')}>
          {he.calendar.allPartners}
        </Segment>
        {partners.map((p) => (
          <Segment
            key={p.id}
            selected={String(filter) === String(p.id)}
            onClick={() => onFilter(p.id)}
          >
            <span className="cal-seg-dot" style={{ background: colorForPartner(p.id, partners) }} />
            {/* My own name reads as "שלי" — the filter I reach for most should say
                what it means to me, not make me find my own name among two. */}
            {String(p.id) === String(me.id) ? he.calendar.onlyMine : p.name}
          </Segment>
        ))}
      </Group>
    </div>
  );
}
